import { Controller } from "@hotwired/stimulus"
import { createConsumer } from "@rails/actioncable"

// Подписка на канал результата АМ.
// ZIP (archive_status) → reload страницы (кнопка «Подготовить/Скачать ZIP» в шапке).
// Перегенерация цветов и генерация палитры/холста обновляют предпросмотр в React
// БЕЗ перезагрузки (pan/zoom сохраняются), поэтому здесь страницу не перезагружаем —
// только показываем/прячем полноэкранный бекдроп на время фоновой работы
// (как #regen-loading-overlay на странице КПН).
// Если страница отрисовала спиннер ZIP, после подписки запрашиваем текущий статус:
// архив мог собраться раньше, чем страница успела подписаться (ArchiveStatusAction).
export default class extends Controller {
  static values = { id: Number }
  static targets = ["archiveSpinner"]

  connect() {
    this.consumer = createConsumer()
    this.subscription = this.consumer.subscriptions.create(
      { channel: "Am::ProcessingResultChannel", am_processing_result_id: this.idValue },
      {
        connected: () => this.requestArchiveStatus(),
        received: (data) => this.handleMessage(data)
      }
    )
  }

  requestArchiveStatus() {
    if (this.hasArchiveSpinnerTarget) this.subscription?.perform("archive_status")
  }

  disconnect() {
    this.subscription?.unsubscribe()
    this.hideLoading()
  }

  handleMessage(data) {
    if (!data || !data.type) return

    switch (data.type) {
      case "archive_status":
        if (data.state === "ready" || data.state === "error") window.location.reload()
        break
      case "regeneration_started":
        this.showLoading("Идёт перегенерация…", "Пожалуйста, подождите")
        break
      case "palette_started":
        this.showLoading("Генерируется печатная палитра", "Пожалуйста, подождите")
        break
      case "production_canvas_started":
        this.showLoading("Генерируется производственный холст", "Пожалуйста, подождите")
        break
      case "tech_card_started":
        this.showLoading("Генерируется техкарта", "Пожалуйста, подождите")
        break
      case "sticker_started":
        this.showLoading("Генерируется этикетка", "Пожалуйста, подождите")
        break
      // Этикетка показывается обычной картинкой, pan/zoom терять нечего —
      // перезагружаем страницу, как на КПН.
      case "sticker_finished":
        window.location.reload()
        break
      case "sticker_error":
        alert("Ошибка при генерации этикетки: " + data.error)
        this.hideLoading()
        window.location.reload()
        break
      case "regeneration_finished":
      case "palette_finished":
      case "production_canvas_finished":
      case "error":
      case "palette_error":
      case "production_canvas_error":
      case "tech_card_finished":
      case "tech_card_error":
        this.hideLoading()
        break
    }
  }

  showLoading(title, subtitle) {
    if (document.getElementById("regen-loading-overlay")) return

    const overlay = document.createElement("div")
    overlay.id = "regen-loading-overlay"
    overlay.style.position = "fixed"
    overlay.style.top = "0"
    overlay.style.left = "0"
    overlay.style.width = "100%"
    overlay.style.height = "100%"
    overlay.style.backgroundColor = "rgba(255, 255, 255, 0.7)"
    overlay.style.zIndex = "9999"
    overlay.style.display = "flex"
    overlay.style.flexDirection = "column"
    overlay.style.alignItems = "center"
    overlay.style.justifyContent = "center"

    overlay.innerHTML = `
      <div class="spinner-border text-primary mb-3" role="status" style="width: 3rem; height: 3rem;">
        <span class="visually-hidden">Loading...</span>
      </div>
      <div class="h4">${title}</div>
      <div class="text-muted">${subtitle}</div>
    `
    document.body.appendChild(overlay)
  }

  hideLoading() {
    document.getElementById("regen-loading-overlay")?.remove()
  }
}
